function TotalNightsIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill="#fff" d="M0 0h60v60H0z" />
      <path
        d="M19.903 31.583a5.833 5.833 0 005.84-5.84 5.833 5.833 0 00-5.84-5.841 5.833 5.833 0 00-5.841 5.84 5.833 5.833 0 005.84 5.841zm23.362-11.681H27.69V33.53H12.115V16.008H8.221V45.21h3.894v-5.84h35.044v5.84h3.894V27.69a7.786 7.786 0 00-7.788-7.787z"
        fill="#A8ADB2"
      />
    </svg>
  )
}

export default TotalNightsIcon
